import React from 'react';
import {ReactComponent as Logo} from 'logo.svg';

const SplashPage = ({ className }) =>
    <div className={className}>
        <Logo />
    </div>

export default SplashPage;
